import request from '@/utils/request';
import { TableListQueryParams, InfoParamsType, CoollectFormDataType, userParamsType, getBagType } from './data.d'
import qs from 'qs'

//获取揽收列表信息
export async function getPickupOrderPageList(params:TableListQueryParams) {
    return request({
        url: '/seller/v1/pickupOrder/getPickupOrderPageList',
        method: 'POST',
        data: params
    })
}

//查询揽收单信息
export async function getPickupOrderByPickupCode(params:InfoParamsType) {
    return request({
        url: '/seller/v1/pickupOrder/getPickupOrderByPickupCode',
        method: 'GET',
        params
    })
}

export async function getWaitShipmentOrder(params:userParamsType) {
    return request({
        url: '/seller/v1/order/getWaitShipmentOrder',
        method: 'GET',
        params
    })
}

//新增揽收单
export async function addPickupOrder(params:CoollectFormDataType) {
    return request({
        url: '/operator/v1/pickupOrder/addPickupOrder',
        method: 'POST',
        data: params
    })
}

//修改/更新揽收单信息
export async function chagePickupOrder(params:CoollectFormDataType) {
    return request({
        url: '/seller/v1/pickupOrder/chagePickupOrder',
        method: 'POST',
        data: params
    })
}

// 获取揽收小包关联关系
export async function getBag(params:getBagType) {
    return request({
        url: '/seller/v1/pickupSmallBag/getBagByPickupCode',
        method: 'GET',
        params
    })
}

//根据揽收编号取消揽收单信息
export async function cancelPickupOrder(params:InfoParamsType) {
    return request({
        url: '/seller/v1/pickupOrder/cancelPickupOrder',
        method: 'GET',
        params
    })
}